module.exports = __webpack_public_path__ + "img/we_1.fcc7416c.svg";